import { useTranslation } from 'react-i18next'

import PlainNav from 'app/common/ui-next/plain-nav'
import Link from 'app/common/lib/link'

import styles from './SettingsPageNavigation.scss'


export enum SettingsSubPage {
  Limits = 'limits',
  Subsidies = 'subsidies',
  Pin = 'pin'
}

export const isSettingsSubPage = (subPage: any): subPage is SettingsSubPage => {
  return Object.values(SettingsSubPage).includes(subPage)
}

type Props = {
  baseUrl: string
  availableSections: Array<SettingsSubPage>
  active: SettingsSubPage | null
}

export const SettingsPageNavigation = ({ baseUrl, availableSections, active }: Props) => {
  const { t } = useTranslation('cafeteria')

  return (
    <nav>
      <PlainNav className={styles.navigation} NavComponent={Link}>
        {availableSections.includes(SettingsSubPage.Limits)
          && <PlainNav.Item to={`${baseUrl}/${SettingsSubPage.Limits}`} active={active === SettingsSubPage.Limits}>
            {t('settings_nav_limits', 'Лимит расходов')}
          </PlainNav.Item>}

        {availableSections.includes(SettingsSubPage.Subsidies)
          && <PlainNav.Item to={`${baseUrl}/${SettingsSubPage.Subsidies}`} active={active === SettingsSubPage.Subsidies}>
            {t('settings_nav_subsidies', 'Справки на дотации')}
          </PlainNav.Item>}

        {availableSections.includes(SettingsSubPage.Pin)
          && <PlainNav.Item to={`${baseUrl}/${SettingsSubPage.Pin}`} active={active === SettingsSubPage.Pin}>
            {t('settings_nav_pin', 'Пин-код')}
          </PlainNav.Item>}
      </PlainNav>
    </nav>
  )
}
